<template>
    <div class="kraken-skewband">
        <div class="kraken-skewband-passingtext">DESARROLLO - DISEÑO - CREATIVIDAD - PROGRESO - KRAKEN LABS - AVANCE - MEJORA - ADELANTO - GENERACIÓN - VALIDACIÓN - KRAKEN LABS - CONSECUCIÓN - EXPANSIÓN - FUERZA - LUCHA - VIDA - KRAKEN LABS - FORTALEZA - RECONOCIMIENTO - PASIÓN - IMAGINACIÓN - KRAKEN LABS</div>
    </div>
</template>

<script lang="ts">
    import Vue from 'vue'

    export default Vue.extend({
        name: 'SkewBand'
    })
</script>

<style scoped lang="scss">
    .kraken-skewband {
        background: #fff;
        height: 60vh;
        // max-height: 760px;
        width: 100%;
        position: relative;
        overflow: hidden;

          &::after {
            content: '';
            width: 45%;
            border-radius: 12px;
            height: 10px;
            background: #393B43;
            position: absolute;
            left: -40%;
            top: 80%;
            box-shadow: -200px -40px 0 #393B43, 200px 40px 0 #393B43;
            animation: moving-bars infinite 4s ease-out;
          }

        &-passingtext {
            position: absolute;
            top: 0;
            white-space: nowrap;
            margin-top: .6rem;
            font-size: 1.3rem;
            animation: passingText infinite 30s linear;
        }
          
    }

    @keyframes passingText {
        from {
            right: -150%;
        }
        to {
            right: 150%;
        }
    }

    @media SCREEN AND ( min-width: 1600px ) {
        .kraken-skewband {
            height: 65vh;
        }
    }

    @keyframes moving-bars {
        0% {
            left: -90%;
            width: 45%;
        }
        100% {
            width: 100%;
            left: 110%;
        }
    }
</style>